import React from "react";
import "../../styles/common/roleAccessBadge.scss";

const RoleAccessBadge = ({ role }) => (
  <span className={`role-access-badge ${role === "SystemAdmin" ? "system-admin" : "community-manager"}`} title={`Minimum role: ${role}`}>
    <i className="fa fa-shield" aria-hidden="true"></i>
    {role}
  </span>
);

export default RoleAccessBadge;
